























import Vue from "vue";
import { Header } from "@/components/MyTable.vue";
import { axios } from "../../../plugins";

const headers: Header[] = [
  { title: "名称", key: "metadata.name", minWidth: 200 },
  { title: "状态", key: "", width: 140 },
  { title: "主机名称(IP)", key: "spec.nodeName", width: 200 },
  { title: "容器组IP", key: "", width: 150 },
  { title: "创建时间", key: "", width: 178 }
];
export default Vue.extend({
  name: "Pod",
  props: {
    data: { type: Object },
    projectId: { type: String }
  },
  data() {
    return {
      headers,
      loadType: "",
      // 翻页禁止参数
      disabled: false,
      monitorData: null as any,
      showMonitor: false,
      tableData: []
    };
  },
  mounted() {
    this.getTable();
  },
  methods: {
    getTable() {
      axios
        .get(`/jobs/${this.projectId}/job/${this.data.name}/pods`)
        .then(res => {
          this.tableData = res.data.data;
        });
    }
  }
});
